<template> 
  <div class="container" v-if="myBookings" style="min-height: 700px;">
    <div class="row margin-bottom-10 margin-top-20 mybookings-header">
      <div class="col-12">
        <div class="card afas-gold">
          <div class="card-content">
            <h5 class="margin-top-10 margin-bottom-10 white-text">My Bookings</h5>
            <a class="waves-effect waves-light white teal-text btn-small btn-block back-button" @click="goBack">Go Back</a>
          </div>
        </div>
      </div>
    </div>
      <div class="progress" v-if="loading">
            <div class="indeterminate"></div>
    </div>
    <span v-if="!loading">
    <div class="row calendar-card card" v-if="bookings.length < 1">
    <div class="col-12 card-content center">
              <p class="red-text">There are no bookings yet for this period.</p>
          </div>
    </div>
    </span> 
    <span v-if="!loading">
      <div class="row calendar-card card" v-if="bookings.length > 0">
          <div class="col-12 card-content">
                <div class="row">
                    <div class="col-12">
                        <table class="striped highlight responsive-table">
                            <thead>
                                <th>Date</th>
                                <th>Day</th>
                                <th>Office</th>
                                <th>Status</th>
                                <th>Actions</th>
                            </thead>
                            <tbody>
                                <tr class="scale-transition" :class="{ 'just-deleted': booking.id == justDeletedId }" v-for="booking in bookings" :key="booking.id">
                                    <td width="150px">{{ booking.date }}</td>
                                    <td width="270px">{{ booking.day }}
                                        <span v-if="!booking.timeslot">(
                                            <span v-if="booking.shift == 1">Full Day</span>
                                            <span v-if="booking.shift == 2">Morning</span>
                                            <span v-if="booking.shift == 3">Afternoon</span>)
                                        </span>
                                        <span v-if="booking.timeslot">
                                            <span>({{ booking.timeslot }})</span>
                                        </span>
                                    </td>
                                    <td>{{ booking.location }}</td>
                                    <td>
                                        <span v-if="booking.approved == true || booking.approved == null" class="new badge teal" data-badge-caption=" ">Approved</span>
                                        <span v-if="booking.approved == false" class="new badge red" data-badge-caption=" ">Not Approved</span>
                                    </td>
                                    <td class="center delete-icon" width="50px"><i v-if="booking.id != justDeletedId" class="material-icons red-text" @click="deleteBookingDialog(booking)">delete</i></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        </span>
        <v-dialog />
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment'
export default {
name: 'MyBookings',
data () {
    return {
        bookings: null,
        selectedBookingToDelete: null,
        justDeletedId: null,
        loading: true,
    }
  },
  computed: {
      ...mapGetters(['myBookings']),
  },
  methods: {
    ...mapActions(['setMyBookings', 'deleteBooking']),
    goBack() {
        this.$router.go(-1);
    },
    createDatesFromTimestamps(){

        this.bookings = this.myBookings;

        for(var i = 0; i < this.bookings.length; i++){

            if(!this.bookings[i].date_string) {
                this.bookings[i].date = moment(this.bookings[i].timestamp).format("Do MMM")
                this.bookings[i].day = moment(this.bookings[i].timestamp).format("dddd")
            } else {
                //transform date_string dd-mm-yyyy to mm-dd-yyyy for moment
                var dateParts = this.bookings[i].date_string.split("-");
                this.bookings[i].date_string_adjusted = dateParts[1] + "-" + dateParts[0] + "-" + dateParts[2];

                this.bookings[i].date = moment(this.bookings[i].date_string_adjusted).format("Do MMM")
                this.bookings[i].day = moment(this.bookings[i].date_string_adjusted).format("dddd")
            }

        }

        this.bookings.sort((a, b) => a.timestamp - b.timestamp );
        this.loading = false;
        
    },
    deleteBookingDialog(booking) {
        this.selectedBookingToDelete = booking,
        this.$modal.show('dialog', {
            title: 'For Sure?',
            text: 'Are you sure that you want to delete the booking of <strong class="teal-text">' + booking.day + " " + booking.date + "</strong> in <strong class='teal-text'>" + booking.location + "</strong>?",
            buttons: [
                {
                title: 'Annuleren',
                    handler: () => {
                        this.$modal.hide('dialog')
                    }
                },
                {
                title: 'Bevestigen',
                    handler: async () => {
                        await this.deleteBooking(booking.id);
                        await this.setMyBookings();
                        this.justDeletedId = this.selectedBookingToDelete.id
                        this.$modal.hide('dialog')
                        setTimeout(()=>{
                            this.justDeletedId = null
                            this.bookings = this.bookings.filter(x => x.id != this.selectedBookingToDelete.id);
                        }, 2000)
                    }
                }
            ]
        })
    }
  },
  async created() {
    await this.setMyBookings();
    this.createDatesFromTimestamps()
  }
}
</script>

<style scoped>

    .calendar-card {
        position: relative;
    }

    .mybookings-header .back-button {
        position: absolute;
        top: 15px;
        right: 15px;;
    }

    .delete-icon {
        cursor: pointer;
    }

    .delete-icon:hover {
        color: grey;
    }

    .just-deleted {
        text-decoration: line-through;
        background-color: rgba(255, 0, 0, 0.3);
    }

</style>


// WEBPACK FOOTER //
// src/components/bookings/MyBookings.vue